import './SellerStatusStyle.less';

import { Icon } from '@opendoor/bricks';
import classNames from 'classnames';
import React from 'react';

export interface ISellerStatusProps {
  statusText: string;
  type: 'approved' | 'needs-attention' | 'pending';
}

const TYPE_ICON: { [type: string]: string } = {
  approved: 'ic-check-filled',
  'needs-attention': 'ic-exclamation-point',
  pending: 'ic-exclamation-point',
};

const SellerStatus: React.SFC<ISellerStatusProps> = (props: ISellerStatusProps) => {
  return (
    <div className={classNames('resale-closing-dashboard-seller-status', props.type)}>
      <Icon name={TYPE_ICON[props.type]} />
      {props.statusText}
    </div>
  );
};

export default SellerStatus;
